import { apiSlice } from "../../app/api/apiSlice";

export const createOBReLockRequestSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createOBReLockRequest: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/loan/create_ob_re_lock_submit_request/`,
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useCreateOBReLockRequestMutation } = createOBReLockRequestSlice;
